export function serializePrincipals(entry) {
    return {
        id: entry?.id,
        name: entry?.name,
        uen: entry?.uen
    }
}